export const NEXT_PROPS_ERROR_KEY_NAME = "__error__";
